<template>
  <Card
    :class="['w-full', height]"
    pt:body:class="p-0! flex flex-col flex-1 min-h-0"
    pt:content:class="p-0! flex flex-col flex-1 min-h-0 bg-surface-200 dark:bg-surface-800 rounded-b-xl"
  >
    <template #header>
      <div class="flex flex-row px-5 h-12 justify-center">
        <div class="flex flex-col justify-center">
          <div class="flex flex-row flex-1 justify-center gap-1">
            <i :class="'pi pi-' + icon + ' text-xl! my-auto'"></i>
            <div class="-ml-2 mr-1">
              <slot name="badges"> </slot>
            </div>
            <h1 class="font-bold text-xl my-auto">{{ header }}</h1>
          </div>

          <p v-if="subtitle" class="text-center text-sm text-surface-500 dark:text-surface-400">
            {{ subtitle }}
          </p>
        </div>

        <IconButton v-if="buttonIcon" class="absolute top-2 right-3" :icon="buttonIcon" rounded small @click="emit('headerClicked')"></IconButton>
      </div>
    </template>
    <template #content>
      <div class="relative flex-1 min-h-0 overflow-hidden my-2 fade-container">
        <ScrollPanel class="h-full" pt:bary="bg-white! dark:bg-surface-600!">
          <div class="p-4">
            <slot name="content"></slot>
          </div>
        </ScrollPanel>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
interface Props {
  header: string;
  icon: string;
  buttonIcon?: string;
  subtitle?: string;
  height?: string;
}
const props = withDefaults(defineProps<Props>(), {
  height: "h-72",
});

const emit = defineEmits<{
  headerClicked: [];
}>();
</script>
